export default __webpack_public_path__ + "static/media/EqualityPortfolioGirl.58df50cb.svg";